import React, { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { useTitle } from "../../components/TitleContext";
import KeyboardShortcuts from "../../components/KeyBoardShortCuts";
import Icon from "../../components/ui/Icon";

const Home: React.FC = () => {
  const auth = useAuth();
  const { setTitle, setSubtitle } = useTitle();

  useEffect(() => {
    setTitle("Home");
    setSubtitle("");
  }, [setTitle]);

  const firstName = auth.login;

  return (
    <div className="bg-gradient-to-br from-gray-50 to-gray-100">
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
          <div className="flex items-center gap-4">
            <div>
              <h1 className="text-3xl font-display font-bold text-gray-900">Welcome back, {firstName} 👋</h1>
              <p className="text-sm text-gray-500">Ready to translate with style</p>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
        {/* Main Content Card */}
        <div className="bg-white overflow-hidden shadow-lg rounded-2xl border border-gray-100">
          <div className="px-6 py-8 sm:p-8">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-14 h-14 bg-gradient-to-r from-emerald-400 to-blue-500 rounded-2xl flex items-center justify-center shadow-lg text-white text-xl">
                <Icon icon="globe" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Sylob Translation Platform</h2>
                <p className="text-gray-600 leading-relaxed">
                  A modern React web application created by Sylob developers to translate ERP data and help make the
                  Sylob ERP I18N. Future updates will include interactive timeline diagrams for translation
                  visualization.
                </p>
              </div>
            </div>
            {/* Shortcuts Section */}
            <div className="border-t border-gray-100 pt-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-gray-800">Quick Reference</h3>
              </div>
              <KeyboardShortcuts />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Home;
